import { defineStore } from "pinia";
import api from "@/services/axios";



export const useItemStore = defineStore("item", {
  state: () => ({
    selectedElement: null,
    elements: [], // Optionnel : cache local si besoin
  }),

  actions: {
    setActiveItem(item) {
      this.selectedElement = item;
    },

    resetState() {
      this.selectedElement = null;
    },

    async saveItem(item, ELmetadata) {
      try {
        // 🔁 Fusionner les métadonnées dans l'objet envoyé
        const itemToSend = {
          ...item,
          metadata: {
            ...(item.metadata || {}),
            ...ELmetadata
          }
        }

        // 🧹 Nettoyer les champs en double pour TextPuzzle
        if (itemToSend.el_Type === 'textPuzzle' && itemToSend.el_InteractionData) {
          // Supprimer les champs qui sont maintenant dans el_InteractionData
          delete itemToSend.gaps
          delete itemToSend.dragElements  
          delete itemToSend.el_SourceText
          delete itemToSend.pointsPerCorrect
          delete itemToSend.penaltyPerIncorrect
        }
    
        const res = await api.post(`/items`, itemToSend)
    
        return res.data
      } catch (err) {
        console.error("❌ Erreur lors de la sauvegarde de l'item :", err)
        console.error("❌ Réponse du serveur:", err.response?.data)
        throw err
      }
    },

    async updateItem(id, updatedData) {
      try {
        const res = await api.put(`/items/${id}`, updatedData);
        console.log(`🔄 Item mis à jour (ID: ${id}) :`, res.data);
        return res.data;
      } catch (err) {
        console.error(`❌ Erreur mise à jour item ${id} :`, err);
        throw err;
      }
    },

    async deleteItem(id) {
      try {
        await api.delete(`/items/${id}`);
        console.log(`🗑️ Item supprimé (ID: ${id})`);
      } catch (err) {
        console.error(`❌ Erreur suppression item ${id} :`, err);
        throw err;
      }
    },
  },

  getters: {
    hasSelected: (state) => !!state.selectedElement,
    selectedLabel: (state) => state.selectedElement?.el_Label || "Aucun item sélectionné",
  },
});
